import {
    CrownOutlined,
    DeleteOutlined,
    EditOutlined,
    MailOutlined,
    MenuOutlined,
    PhoneOutlined,
    PlusOutlined,
} from '@ant-design/icons'
import {
    Button,
    Col,
    Dropdown,
    Input,
    Menu,
    Modal,
    notification,
    Row,
    Spin,
    Switch,
    Table,
    Tooltip,
} from 'antd'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { deleteUserApi, deleteUserSummaryApi, listOfUsersApi, updateUserApi } from '../../../config/Api'
import { apiErrorMessage } from '../../../services/ApiError'
import { API_ERR_MESSAGE, USERS } from '../../../config/constant'
import { setHeaderName } from '../../../services/SetHeaderName'
import './style/UsersList.scss'
import { SetPlanModal } from './SetPlanModal'
// import { AddPlanPricing } from "./AddPlanPricing";

export const UsersList = () => {
    const data = [
        {
            id: '1001',
            name: 'John Brown',
            rights: 'Add Recipes',
            email: 'mansi.hbhojani@gmail.com',
            mobile: '097234 49697',
            active_clients: 32,
            rating: 5,
            status: false,
        },
        {
            id: '1002',
            name: 'Aakash Parekh',
            rights: 'Add & Edit Recipes',
            email: 'ap@gmail.com',
            mobile: '097234 55555',
            active_clients: 15,
            rating: 4,
            status: true,
        },
        {
            id: '1003',
            name: 'Darshit Lathigara',
            rights: 'Manage Recipes',
            email: 'dl@gmail.com',
            mobile: '45781 49697',
            active_clients: 50,
            rating: 4.5,
            status: true,
        },
        {
            id: '1004',
            name: 'Divy Adesara',
            rights: 'Add Recipes',
            email: 'divy@gmail.com',
            mobile: '55555 49697',
            active_clients: 40,
            rating: 4.2,
            status: false,
        },
        {
            id: '1005',
            name: 'Sagar Parekh',
            rights: 'View Recipes',
            email: 'sagar@gmail.com',
            mobile: '097234 11111',
            active_clients: 100,
            rating: 4.7,
            status: true,
        },
    ]
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [isPlanActive, setIsPlanActive] = useState(false)
    const [listOfUserDisplay, setListOfUserDisplay] = useState([])
    const [dataSource, setDataSource] = useState([])
    const [value, setValue] = useState('')

    const [displayData, setDisplayData] = useState([])
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [usersData, setUsersData] = useState()
    const [editDiseasesRecord, setEditDiseasesRecord] = useState()
    const [loading, setLoading] = useState(false)
    // doctor whose plan the admin is setting (Set plan)
    const [planDoctor, setPlanDoctor] = useState(null)

    const FilterApiData = (apiData) => {
        if (apiData) {
            if (apiData.length > 0) {
                let data = apiData.filter(
                    (element) => element.role == 'Nutritionist'
                )
                return data
            }
        }
    }

    // get the list of all nutritionist
    //==============================
    const getListOfUsers = () => {
        setLoading(true)
        listOfUsersApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(FilterApiData(res.data.data))
                    setDisplayData(FilterApiData(res.data.data))
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }
    // permanently delete a user after confirming what will be removed
    //==============================
    const plural = (count, word) => `${count} ${word}${count === 1 ? '' : 's'}`

    const confirmDeleteUser = (record) => {
        deleteUserSummaryApi(record.id)
            .then((res) => {
                const summary = res.data.data
                const moved = summary.moved_to_admin
                const movedCount = moved.programs + moved.recipes + moved.herbs

                Modal.confirm({
                    title: `Delete ${record.name}?`,
                    okText: 'Delete permanently',
                    okType: 'danger',
                    cancelText: 'Cancel',
                    content: (
                        <div>
                            <p>This permanently deletes the account and everything it owns:</p>
                            <ul>
                                <li>{plural(summary.clients, 'client')} (with their diets, herbs, measurements, medical data and notes)</li>
                                <li>{plural(summary.programs, 'program')}</li>
                                <li>{plural(summary.recipes, 'recipe')}</li>
                                <li>{plural(summary.herbs, 'custom herb')}</li>
                            </ul>
                            {movedCount > 0 && (
                                <p>
                                    Kept and moved to you, because other nutritionists' clients use them:{' '}
                                    {plural(moved.programs, 'program')}, {plural(moved.recipes, 'recipe')}, {plural(moved.herbs, 'herb')}.
                                </p>
                            )}
                            <p className="fw-bold text-danger mb-0">This cannot be undone.</p>
                        </div>
                    ),
                    // returning the promise keeps the dialog open with a spinner until the delete finishes
                    onOk: () =>
                        deleteUserApi(record.id)
                            .then((res) => {
                                notification.success({ message: res.data.message })
                                getListOfUsers()
                            })
                            .catch((err) => {
                                notification.error({ message: apiErrorMessage(err) })
                            }),
                })
            })
            .catch((err) => {
                notification.error({ message: apiErrorMessage(err) })
            })
    }

    // update status of recipe category
    //==============================
    const onChange = (checked, data) => {
        let updatedData = data
        updatedData.status = checked

        updateUserApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: 'Users Status Update successfully',
                    })
                    getListOfUsers()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }


    const verifyPhone = (data) => {
        let updatedData = data
        updatedData.is_mobile_verified = 1
        updateUserApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: 'Phone marked as verified',
                    })
                    getListOfUsers()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }

    useEffect(() => {
        getListOfUsers()
        setHeaderName(USERS)
        // setDataSource(data)
    }, [])

    // filter data according to user search input
    //==============================
    useEffect(() => {
        filterUsers(usersData)
    }, [usersData])

    // filter User(Nutitionist) List
    //==============================
    const filterUsers = (data) => {
        if (!data) {
            setDisplayData(dataSource)
        } else {
            let tmp = []
            dataSource.length > 0 &&
                dataSource.forEach((element) => {
                    if (
                        element.name
                            .toUpperCase()
                            .indexOf(data.toUpperCase()) !== -1
                    ) {
                        tmp.push(element)
                    }
                })
            setDisplayData(tmp)
        }
    }

    const ActionMenu = (
        <Menu>
            <Menu.Item>
                <MailOutlined className="me-2" />
                Verify Email
            </Menu.Item>
            <Menu.Item>
                <PhoneOutlined className="me-2" />
                Verify Phone
            </Menu.Item>
            <Menu.Item>
                {/* <Link
                    to={{ pathname: `/edit-user/${record.id}` }}
                    className="dropdown-item"
                > */}
                <EditOutlined className="me-2" />
                Edit
                {/* </Link> */}
            </Menu.Item>
            <Menu.Item>
                <DeleteOutlined className="me-2" />
                Delete
            </Menu.Item>
        </Menu>
    )

    const columns = [
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'name',
        //     defaultSortOrder: 'ascend',
        //     sorter: (a, b) => a.id - b.id,
        //     // render: (text) => <a>{text}</a>,
        // },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'active_client',
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            sorter: (a, b) => a.name.localeCompare(b.name),
            render: (text, record) => (
                <>
                    {record.email}
                    {record.is_email_verified == 1 ||
                    record.is_email_verified == true ? (
                        <Tooltip title="Email is Verified">
                            <MailOutlined
                                className="ms-2"
                                style={{ color: 'green' }}
                            />
                        </Tooltip>
                    ) : (
                        <Tooltip title="Email is not Verified">
                            <MailOutlined
                                className="ms-2"
                                style={{ color: 'red' }}
                            />
                        </Tooltip>
                    )}
                </>
            ),
        },
        // {
        //     title: 'Rights',
        //     // dataIndex: 'rights',
        //     dataIndex: ['herbs_management_right', 'measurements_management_right', 'add_recipes_right'],
        //     key: 'price',
        //     filters: [
        //         { text: "Herbs Management", value: true },
        //         { text: "Measurements Management", value: false },
        //         { text: "Add Recipes", value: false },
        //     ],
        //     render: (_, record) => (
        //         <>
        //             {record.herbs_management_right && <Tag className="rounded" color="#108ee9">Herbs Management</Tag>}
        //             {record.measurements_management_right && <Tag className="rounded" color="#2db7f5">Measurements Management</Tag>}
        //             {record.add_recipes_right && <Tag className="rounded" color="#87d068">Add Recipe</Tag>}
        //         </>
        //     ),
        // },
        {
            title: 'Mobile',
            dataIndex: 'phone',
            key: 'price',
        },
        {
            title: 'Plan',
            dataIndex: 'plan',
            key: 'price',
            defaultSortOrder: 'ascend',
            render: (_, record) => <p>{record.plan?.name}</p>,
        },
        {
            title: 'Active Client',
            dataIndex: 'plan',
            key: 'price',
            render: (_, record) => <p>{record?.plan?.active_clients || 0}</p>,
        },
        // {
        //     title: 'Rating',
        //     dataIndex: 'rating',
        //     key: 'plan_status',
        //     defaultSortOrder: 'ascend',
        //     sorter: (a, b) => a.rating - b.rating,
        // },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'price',
            render: (text, data) => (
                <>
                    <Switch
                        checked={text}
                        onChange={(e) => {
                            setIsActive(!isActive)
                            onChange(e, data)
                        }}
                    />
                </>
            ),
            filters: [
                { text: 'Active', value: true },
                { text: 'Deactive', value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    {/* <Dropdown overlay={ActionMenu} placement="bottom" arrow={{ pointAtCenter: true }} >
                        <Button icon={<MenuOutlined />} className="me-2" />
                    </Dropdown> */}
                    <Dropdown
                        className="w-100"
                        overlay={
                            <Menu className="w-100">
                                <Menu.Item
                                // onClick={() => { setClientData(record); setIsModalVisible(true) }}
                                >
                                    <Link
                                        to={{
                                            pathname: `/edit-user/${record.id}`,
                                        }}
                                        className="dropdown-item"
                                    >
                                        {/* <EditOutlined className="me-2" /> */}
                                        <EditOutlined className="me-2" />
                                        Edit
                                    </Link>
                                </Menu.Item>
                                {/* {!record.is_mobile_verified && (
                                    <Menu.Item
                                        onClick={() => verifyPhone(record)}
                                    >
                                        <PhoneOutlined className="me-2" />
                                        Verify Phone
                                    </Menu.Item>
                                )} */}
                                {record.role !== 'Admin' && (
                                    <Menu.Item onClick={() => setPlanDoctor(record)}>
                                        <CrownOutlined className="me-2" />
                                        Set plan
                                    </Menu.Item>
                                )}
                                <Menu.Item
                                    danger
                                    onClick={() => confirmDeleteUser(record)}
                                >
                                    <DeleteOutlined className="me-2" />
                                    Delete
                                </Menu.Item>
                            </Menu>
                        }
                        placement="bottom"
                        arrow={{ pointAtCenter: true }}
                    >
                        <Button icon={<MenuOutlined />} className="me-2" />
                    </Dropdown>
                </div>
            ),
        },
    ]

    // filter data
    // const filterUsers = (userData) => {

    //     let filteredList = data.filter(freight =>
    //         Object.keys(freight).some(
    //             key =>
    //                 freight[key]
    //                     .toLowerCase()
    //                     .indexOf(data.name.toLowerCase()) !== -1,
    //         ),
    //     );
    //     console.log("userData", filteredList)
    //     const result = data.includes(userData)
    //     console.log("result", result)
    // };

    return (
        <>
            <div className="UserList">
                <Row className="mb-2">
                    <Col md={4} xl={2} className="align-self-center">
                        <Link to={{ pathname: '/add-user' }}>
                            <Button
                                htmlType="submit"
                                className="submit-button  border-0 rounded ms-2 "
                                icon={
                                    <PlusOutlined
                                        style={{ fontSize: '1.2rem' }}
                                    />
                                }
                                onClick={() => setIsModalVisible(true)}
                            >
                                Add
                            </Button>
                        </Link>
                    </Col>
                    <Col
                        md={8}
                        xl={16}
                        className="text-end align-self-center pe-4"
                    >
                        <h6 className="mb-0">
                            Total Users:{' '}
                            {displayData.length > 0 ? displayData.length : 0}{' '}
                        </h6>
                    </Col>
                    <Col md={12} xl={6} className="align-self-center pe-2">
                        {/* <Input.Search placeholder="Search Users" onChange={(e) => filterUserRoles(e.target.value)} className="p-2" /> */}
                        {/* <FilterData data={data} setDataSource={setDataSource} column={' entry.name.toLowerCase().includes(currValue) ||'+
                                'entry.active_clients.toString().includes(currValue) ||'+
                                'entry.email.toLowerCase().includes(currValue) ||'+
                                'entry.rating.toString().includes(currValue) ||'+
                                'entry.rights.toLowerCase().includes(currValue))'} />  */}
                        <Input.Search
                            placeholder="Search Users"
                            onChange={(e) => {
                                filterUsers(e.target.value)
                                setUsersData(e.target.value)
                            }}
                            className="p-2"
                        />
                    </Col>
                </Row>
                <Spin spinning={loading} className="spinner-code">
                    <Row>
                        <Table
                            rowKey="id"
                            columns={columns}
                            dataSource={displayData}
                            // pagination={false}
                            scroll={{ x: 'max-content' }}
                            className="w-100"
                        />
                    </Row>
                </Spin>
            </div>
            <SetPlanModal doctor={planDoctor} onClose={() => setPlanDoctor(null)} onSaved={getListOfUsers} />
        </>
    )
}
